import { render } from "./AllInvoicesView.vue?vue&type=template&id=37a448e4&scoped=true&ts=true"
import script from "./AllInvoicesView.vue?vue&type=script&lang=ts"
export * from "./AllInvoicesView.vue?vue&type=script&lang=ts"

import "./AllInvoicesView.vue?vue&type=style&index=0&id=37a448e4&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a448e4"]])

export default __exports__